import { SectionShell } from "@/components/design-system/SectionShell";
import { FONTS } from "@/components/design-system/palette";

const code = `// Set in design-system.css via @theme:
//   --font-display: 'Scope One', Georgia, serif;
//   --font-sans: 'Hind', -apple-system, ui-sans-serif, system-ui, sans-serif;
//   --font-mono: 'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace;

<h1>Display headline (Scope One — h1 only, never bold)</h1>
<h2>Section heading (Hind, medium weight)</h2>
<p>Body paragraph (Hind).</p>
<code>Terminal & code (JetBrains Mono)</code>`;

export function TypographySection() {
  return (
    <SectionShell
      id="typography"
      title="Typography"
      description={
        <>
          Three families, matching the marketing site. <code>{FONTS.display}</code>{" "}
          is the serif display face — H1 only, single 400 weight, never faux
          bold. <code>{FONTS.body}</code> carries everything else: H2–H6, body,
          small type, UI. <code>{FONTS.mono}</code> is for terminal and code.
          All load from Google Fonts via <code>&lt;link&gt;</code> tags in the
          app's HTML <code>&lt;head&gt;</code>.
        </>
      }
      whenToUse={
        <ul>
          <li>
            Use <code>font-display</code> for the H1/display level only —
            <code>&lt;h1&gt;</code> already inherits it via base styles.
          </li>
          <li>
            Use <code>font-sans</code> for everything else (including H2–H6) —
            already the default.
          </li>
          <li>
            Use <code>font-mono</code> for code, license keys, and
            terminal-style output.
          </li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Don't import additional font families — propose adding to the
            system instead.
          </li>
          <li>Don't override <code>font-family</code> inline.</li>
        </ul>
      }
      preview={
        <div className="space-y-6">
          <div>
            <div className="mb-1 text-xs font-mono text-ink-muted">
              Display — {FONTS.display}
            </div>
            <div className="font-display text-4xl font-normal text-ink-display">
              The quick brown fox jumps over the lazy dog
            </div>
          </div>
          <div>
            <div className="mb-1 text-xs font-mono text-ink-muted">
              Body — {FONTS.body}
            </div>
            <div className="font-sans text-base text-ink-body">
              The quick brown fox jumps over the lazy dog. 0123456789. The
              five boxing wizards jump quickly.
            </div>
          </div>
          <div>
            <div className="mb-1 text-xs font-mono text-ink-muted">
              Mono — {FONTS.mono}
            </div>
            <div className="font-mono text-sm text-ink-body">
              FLYW-1234-ABCD-5678 · npm run check · 0123456789
            </div>
          </div>
        </div>
      }
      code={code}
    />
  );
}
